import type { IconSvgObject } from './types';

const AlignLeftIcon: IconSvgObject = [
  ["path", { d: "M9 10H12.9992C13.5518 10 13.9997 9.55181 13.9992 8.99922L13.9969 5.99922C13.9964 5.44724 13.5489 5 12.9969 5H9C8.44772 5 8 5.44772 8 6V9C8 9.55228 8.44772 10 9 10Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 19H18.9984C19.5513 19 19.9993 18.5513 19.9984 17.9984L19.9937 14.9984C19.9929 14.4468 19.5454 14 18.9937 14H9C8.44772 14 8 14.4477 8 15V18C8 18.5523 8.44772 19 9 19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 2V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default AlignLeftIcon;
